import { Button, Modal, Typography } from '@arco-design/web-react';
import { useTranslation } from 'react-i18next';

import { getButtonColor, getButtonTextColor, getTextColor } from '../../utils/cssVariables';

import './BookMeetingAuthModal.css';

type BookMeetingAuthModalProps = {
  visible: boolean;
  brandName: string;
  mentorName?: string;
  onSignIn: () => void;
  onRegister: () => void;
  onClose: () => void;
};

export const BookMeetingAuthModal = ({
  visible,
  brandName,
  mentorName,
  onSignIn,
  onRegister,
  onClose,
}: BookMeetingAuthModalProps) => {
  const { t } = useTranslation();
  const displayBrand = brandName.trim() || 'WERULE';

  return (
    <Modal
      visible={visible}
      title={null}
      footer={null}
      onCancel={onClose}
      closable
      className="book-meeting-auth-modal-dialog meeting-modal"
      wrapClassName="book-meeting-auth-modal-wrapper"
    >
      <div className="book-meeting-auth-modal">
        <Typography.Title heading={4} className="alice-regular book-meeting-auth-modal__title">
          {t('book_meeting_auth_modal.title')}
        </Typography.Title>
        <Typography.Text
          className="book-meeting-auth-modal__body"
          style={{ color: getTextColor() }}
        >
          {mentorName
            ? t('book_meeting_auth_modal.body_with_mentor', {
                mentorName,
                brandName: displayBrand,
              })
            : t('book_meeting_auth_modal.body', { brandName: displayBrand })}
        </Typography.Text>
        <div className="book-meeting-auth-modal__actions">
          <Button
            shape="round"
            size="large"
            type="outline"
            onClick={onSignIn}
            style={{
              minWidth: 200,
              width: '100%',
              maxWidth: 320,
            }}
          >
            {t('book_meeting_auth_modal.sign_in_button')}
          </Button>
          <Button
            shape="round"
            size="large"
            onClick={onRegister}
            style={{
              color: getButtonTextColor(),
              backgroundColor: getButtonColor(),
              minWidth: 200,
              width: '100%',
              maxWidth: 320,
            }}
          >
            {t('book_meeting_auth_modal.register_button')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
